export class TableSortColumn {

    constructor(public id: string, public ascending = true) {
    }

}
